import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import * as Actions from './actions'
import { callApi } from '../../../../utils/callApi'
import { API_ROUTES } from '../../../../utils/apiRoutes'
import { ActionTypes, TGeneralActivity } from './types'

function* getGeneralActivityWorker(action: ReturnType<typeof Actions.GetGeneralActivity.request>) {
  const { callBack, idTender, offset, limit, search, sortBy, sort } = action.payload as Actions.TypeGetGeneralActivityR
  let success = true
  let data = null

  let query = `?Offset=${offset || 0}&Limit=${limit || 20}`
  query += search ? `&Search=${search}` : ''
  query += sortBy ? `&SortBy=${sortBy}` : ''
  query += sort ? `&Sort=${sort}` : ''
  query += `&Statistic=true`

  try {
    data = (yield call(callApi, {
      method: 'get',
      path: `${API_ROUTES.adminTenders}/${idTender}/items${query}`,
    })) as TGeneralActivity[]
    if (offset !== 0) {
      yield put(Actions.GetGeneralActivity.success(data))
    } else {
      yield put(Actions.GetGeneralActivityWith0Offset.success(data))
    }
  } catch (e) {
    success = false
    // @ts-ignore
    data = e?.data || e
    yield put(Actions.GetGeneralActivity.error(`${data?.message || data}`))
  } finally {
    if (callBack) callBack(success, data)
  }
}

function* watchRequest() {
  yield takeEvery(ActionTypes.GET_GENERAL_ACTIVITY_R, getGeneralActivityWorker)
}

export default function* generalActivitySaga() {
  yield all([fork(watchRequest)])
}
